import { MutationOptions } from 'react-query';

import { queryClient } from '../../../queryClient';

import { ORG_PERMISSIONS_QUERY_KEY_PREFIX } from './org-permissions.query';
import { OrgPermission } from './org-permissions.schema';
import {
  addOrgPermission,
  PermissionRole,
  removeOrgPermission,
  updateOrgPermission,
} from './org-permissions.api';
import { EmptyResponse } from '../../schemas/EmptyResponseSchema';

export const getUpdateOrgPermissionMutation = (
  orgId: number,
  permissionId: number,
): MutationOptions<OrgPermission, unknown, PermissionRole> => ({
  mutationFn: newRole => updateOrgPermission(orgId, permissionId, newRole),
  onSuccess: () =>
    queryClient.invalidateQueries(ORG_PERMISSIONS_QUERY_KEY_PREFIX),
});

export const getAddOrgPermissionMutation = (
  orgId: number,
  auth0UserId: string,
): MutationOptions<OrgPermission, unknown, PermissionRole> => ({
  mutationFn: newRole => addOrgPermission(orgId, auth0UserId, newRole),
  onSuccess: () =>
    queryClient.invalidateQueries(ORG_PERMISSIONS_QUERY_KEY_PREFIX),
});

export const getRemoveOrgPermissionMutation = (
  orgId: number,
  permissionId: number,
): MutationOptions<EmptyResponse, unknown, void> => ({
  mutationFn: () => removeOrgPermission(orgId, permissionId),
  onSuccess: () =>
    queryClient.invalidateQueries(ORG_PERMISSIONS_QUERY_KEY_PREFIX),
});
